import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUIModule } from 'ng-block-ui';
import * as Sentry from '@sentry/angular';
import { ConfigService } from './shared/_services/config.service';
import { OpenTelemetryService } from './shared/_services/open-telemetry.service';

@Component({
	selector: 'app-root',
	imports: [BlockUIModule, RouterOutlet],
	template: `
    <block-ui>
      <router-outlet></router-outlet>
    </block-ui>
  `,
	styles: [],
})
export class AppComponent {
	lingua: string = '';

	constructor(
		config: ConfigService,
		openTelemetryService: OpenTelemetryService,
		translate: TranslateService,
		@Inject(DOCUMENT) document: Document,
	) {
		// Allinea l'attributo lang alla lingua corrente, altrimenti il browser propone/applica la traduzione automatica sui testi già tradotti
		document.documentElement.lang = translate.currentLang || 'it';
		translate.onLangChange.subscribe(({ lang }) => (document.documentElement.lang = lang));

		// Configurazione Sentry
		if (config.configuration.sentryEnabled) {
			Sentry.init({
				dsn: config.configuration.sentryDsn,
				environment: config.configuration.environment,
				integrations: [],
				release: `RELEASE_${config.configuration.buildNumber}`,
			});
		}

		// Configurazione OpenTelemetry
		if (config.configuration.openTelemetryEnabled) {
			const openTelemetryOptions = {
				apiUrl: config.configuration.openTelemetryApiUrl,
				serviceName: config.configuration.openTelemetryServiceName,
				attributes: config.configuration.openTelemetryAttributes + config.configuration.environment,
				trace: true,
				log: true,
			};
			openTelemetryService.inizializza(openTelemetryOptions);
			const { utente } = JSON.parse(localStorage['user'] || '{}');
			openTelemetryService.attributiFissi.idUtente = utente ? String(utente.idUtente) : '';
			openTelemetryService.attributiFissi.emailUtente = utente ? utente.email : '';
			openTelemetryService.attributiFissi.nomeUtente = utente ? `${utente.nome} ${utente.cognome}` : '';
			openTelemetryService.abilitaLoggingPagineVisitate();
		}
	}

}
